// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8qMIBPTI","blocksWrapper":"CNgstZhQ","icon":"_8_8SrNLj","header":"EUsR0B8W"};